import * as Yup from 'yup'
import { parsePhoneNumberFromString } from 'libphonenumber-js/mobile'
import { BRIEF_TYPE, WEEK_DAYS, GENDER_ANY } from '../index'

Yup.addMethod(Yup.string, 'phoneNumber', function(formatMessage) {
  return this.test({
    name: 'phoneNumber',
    exclusive: true,
    message: formatMessage({ id: 'Brief.schema.phone.inValid' }),
    test: value => {
      if (!value) return true

      try {
        return parsePhoneNumberFromString(value, 'RU').isValid()
      } catch (e) {
        return false
      }
    }
  })
})

export const initialValues = formatMessage => ({
  source: 'services',
  platform: BRIEF_TYPE.SEARCH,
  goods: '',
  showRegions: '',
  gender: GENDER_ANY,
  age: '',
  advantages: [
    { text: formatMessage({ id: 'Brief.initial.advantages1' }) },
    { text: formatMessage({ id: 'Brief.initial.advantages2' }) },
    { text: formatMessage({ id: 'Brief.initial.advantages3' }) },
    { text: formatMessage({ id: 'Brief.initial.advantages4' }) }
  ],
  promoAction: '',
  vcardEmail: '',
  vcardPhone: '',
  vcardCity: '',
  vcardAddress: '',
  vcardWorkingDay: WEEK_DAYS,
  vcardStartWorkingTime: formatMessage({ id: 'Brief.initial.startDay' }),
  vcardEndWorkingTime: formatMessage({ id: 'Brief.initial.endDay' }),
  comment: '',
  firstname: '',
  email: '',
  phone: '',
  companyName: '',
  siteUrl: '',
  dataProcessingPermission: false
})

const schemaValidation = (values, formatMessage) => ({
  goods: Yup.string().required(formatMessage({ id: 'Brief.schema.goods.required' })),
  showRegions: Yup.string().required(formatMessage({ id: 'Brief.schema.showRegions.required' })),
  gender: Yup.string().required(formatMessage({ id: 'Brief.schema.checked.required' })),
  age: Yup.string().required(formatMessage({ id: 'Brief.schema.checked.required' })),
  advantages: Yup.array().of(
    Yup.object().shape({
      text: Yup.string().required(formatMessage({ id: 'Brief.schema.required' }))
    })
  ),
  promoAction: Yup.string().max(30, formatMessage({ id: 'Brief.schema.promoAction.max' })),
  vcardEmail: Yup.string()
    .email(formatMessage({ id: 'Brief.schema.email.inValid' }))
    .max(100, formatMessage({ id: 'Brief.schema.email.max' })),
  vcardPhone: Yup.string().phoneNumber(formatMessage),
  vcardCity: Yup.string(),
  vcardAddress: Yup.string(),
  vcardWorkingDay: Yup.string(),
  vcardStartWorkingTime: Yup.string(),
  vcardEndWorkingTime: Yup.string(),
  comment: Yup.string(),
  firstname: Yup.string()
    .required(formatMessage({ id: 'Brief.schema.firstName.required' }))
    .max(100, formatMessage({ id: 'Brief.schema.firstName.max' }))
    .matches(/^[а-яёa-z\s\-]+$/iu, formatMessage({ id: 'Brief.schema.firstName.inValid' })), // eslint-disable-line
  email: Yup.string()
    .email(formatMessage({ id: 'Brief.schema.email.inValid' }))
    .max(100, formatMessage({ id: 'Brief.schema.email.max' }))
    .required(formatMessage({ id: 'Brief.schema.email.required' })),
  phone: Yup.string()
    .required(formatMessage({ id: 'Brief.schema.phone.required' }))
    .phoneNumber(formatMessage),
  companyName: Yup.string().required(formatMessage({ id: 'Brief.schema.company.required' })),
  siteUrl: Yup.string().required(formatMessage({ id: 'Brief.schema.siteUrl.required' })),
  dataProcessingPermission: Yup.boolean()
    .oneOf([true], formatMessage({ id: 'Brief.schema.agreement.required' }))
    .required(formatMessage({ id: 'Brief.schema.agreement.required' }))
})

export const briefSchema = formatMessage =>
  Yup.lazy(values => Yup.object().shape(schemaValidation(values, formatMessage)))
